import { createSlice } from '@reduxjs/toolkit'
import { ApiState } from "@baseTypes/baseType";
import { applyExtraReducer } from "../../weather";
import { createThunk } from "../../dashboard/crops/selector/index";

export interface User {
    title: string
    groupName: string
    id: number
}

interface UsersState extends ApiState {
    data: User[]
}

const initialState: UsersState = {
    data: [],
    apiError: undefined,
    isApiLoading: false
}

const fetchPartnersUsers = createThunk<User>()({url: 'users'});

const userSlice = createSlice({
    name: 'usersSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchPartnersUsers)
    },
})

export const actions = { ...userSlice.actions, fetchPartnersUsers }
export default userSlice.reducer